import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, ShoppingBag } from "lucide-react";
import api from "../lib/api";
import { useSEO } from "../components/site/Reveal";
import { clearCart } from "../lib/cart";

export default function ShopSuccess() {
  useSEO("Order Confirmed", "Thank you for your order from ÀsÀNigHT Worldwide.");
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const paidVia = params.get("paid");
  const [state, setState] = React.useState(paidVia ? "paid" : "checking");
  const pollRef = React.useRef(null);
  const tries = React.useRef(0);

  React.useEffect(() => {
    if (paidVia) { clearCart(); return; }
    if (!sessionId) { setState("error"); return; }
    const check = async () => {
      tries.current += 1;
      try {
        const { data } = await api.get(`/shop/order/${sessionId}`);
        if (data.payment_status === "paid") { clearCart(); setState("paid"); clearInterval(pollRef.current); }
        else if (tries.current > 8) { setState("pending"); clearInterval(pollRef.current); }
      } catch { if (tries.current > 8) { setState("error"); clearInterval(pollRef.current); } }
    };
    check();
    pollRef.current = setInterval(check, 2500);
    return () => clearInterval(pollRef.current);
  }, [sessionId, paidVia]);

  return (
    <div className="min-h-screen grid place-items-center px-6 py-28">
      <div className="text-center max-w-lg" data-testid="shop-success">
        {state === "checking" ? (
          <><Loader2 className="w-12 h-12 text-gold animate-spin mx-auto mb-6" /><h1 className="font-serif text-3xl text-cream">Confirming your payment…</h1></>
        ) : state === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto mb-6" />
            <h1 className="font-serif text-4xl text-cream mb-3">Ẹ ṣé! Order Confirmed</h1>
            <p className="text-cream/70 mb-8">Thank you for your purchase. A receipt has been sent to your email, and we'll be in touch about delivery.</p>
            <Link to="/shop" className="inline-flex items-center gap-2 bg-gold text-night font-semibold px-6 py-3 rounded-full"><ShoppingBag className="w-4 h-4" /> Continue Shopping</Link>
          </>
        ) : state === "pending" ? (
          <><h1 className="font-serif text-3xl text-cream mb-3">Payment Processing</h1><p className="text-cream/70 mb-8">Your payment is being processed. You'll receive a confirmation email shortly.</p><Link to="/shop" className="inline-flex bg-gold text-night font-semibold px-6 py-3 rounded-full">Back to Shop</Link></>
        ) : (
          <><h1 className="font-serif text-3xl text-cream mb-3">Something went wrong</h1><p className="text-cream/70 mb-8">We couldn't confirm this order. If you were charged, please contact us.</p><Link to="/shop/cart" className="inline-flex bg-gold text-night font-semibold px-6 py-3 rounded-full">Back to Cart</Link></>
        )}
      </div>
    </div>
  );
}
